import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  TableContainer,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});
const rows = [
  {
    id: 1,
    vid:1,
    name: "John Doe",
    gst: "22AAAAA0000A1Z5",
    address: "123 Street",
    city: "Chennai",
    state: "Tamil Nadu",
    mobile1: "9876543210",
    email1: "john@example.com",
    sourcedFor: "SMS",
    notes: "VIP customer",
  },
  {
    id: 2,
    vid:2,
    name: "Jane Smith",
    gst: "29BBBBB1111B2Z6",
    address: "456 Avenue",
    city: "Mumbai",
    state: "Maharashtra",
    mobile1: "9988776655",
    email1: "jane@example.com",
    sourcedFor: "Email",
    notes: "Follow up in October",
  },
];

const handleView = (row) => {
  alert(`Viewing: ${row.name}`);
};

const handleEdit = (row) => {
  alert(`Editing: ${row.name}`);
};

const columns = [
  {
    field: "id",
    headerName: "S.No",
    width: 70,
    sortable: false,
  },
  {
    field: "vid",
    headerName: "Vendor ID",
    width: 70,
    sortable: false,
  },
  { field: "name", headerName: "Name", width: 150 },
  { field: "gst", headerName: "GST No", width: 150 },
  { field: "address", headerName: "Address", width: 200 },
  { field: "city", headerName: "City", width: 120 },
  { field: "state", headerName: "State", width: 150 },
  { field: "mobile1", headerName: "Mobile Number", width: 150 },
  { field: "email1", headerName: "Email", width: 200 },
  { field: "sourcedFor", headerName: "Sourced For", width: 130 },
  { field: "notes", headerName: "Notes", width: 200 },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <>
        <Tooltip title="Edit">
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="View">
          <IconButton color="primary" onClick={() => handleView(params.row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      </>
    ),
  },
];

const VendorList = () => {
  const classes = useStyles();
  return (
    <>
      <Card elevation={3} sx={{ marginBottom: "15px" }}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} md={3}>
            <TextField
              label="Name"
              name="name"
              fullWidth
              //   value={filters.name}
              //   onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Advance Search"
              name="mobilenumber"
              fullWidth
              //   value={filters.mobilenumber}
              //   onChange={(e) =>
              //     setFilters({ ...filters, mobilenumber: e.target.value })
              //   }
            />
          </Grid>
          {/* <Grid item xs={12} md={3}>
            <TextField
              label="Email"
              name="mobilenumber"
              fullWidth
              //   value={filters.mobilenumber}
              //   onChange={(e) =>
              //     setFilters({ ...filters, mobilenumber: e.target.value })
              //   }
            />
          </Grid> */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Sourced For</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="Sourced For"
                // onChange={handleChange}
              >
                <MenuItem value="sms">SMS</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="whatsapp">Whatsapp</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">City</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="City"
                // onChange={handleChange}
              >
                <MenuItem value="chennai">Chennai</MenuItem>
                <MenuItem value="madurai">Madurai</MenuItem>
                <MenuItem value="salem">Salem</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">State</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="State"
                // onChange={handleChange}
              >
                <MenuItem value="tamilnadu">Tamilnadu</MenuItem>
                <MenuItem value="kerala">Kerala</MenuItem>
                <MenuItem value="karnataka">Karnataka</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box className={classes.buttonContainer}>
          <Button
            // className={classes.animatedButton}
            variant="outlined"
            // onClick={handleReset}
          >
            Reset
          </Button>
          <Button
            className={classes.animatedButton}
            variant="contained"
            // onClick={handleSearch}
          >
            Search
          </Button>
        </Box>
      </Card>
      <Card elevation={3}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          disableSelectionOnClick
        />
      </Card>
    </>
  );
};

export default VendorList;
